import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './DropDown.css';

const DropDown = ({
  input,
  label,
  name,
  type,
  options,
  meta: { touched, dirty, error },
}) => (
  <div className={styles.dropDownField}>
    <select
      {...input}
      type={type}
      name={name}
      className={
        (touched || dirty) && error ? styles.selectError : styles.select
      }
    >
      <option>---</option>
      {options.map(option => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
    <div className={styles.helpText}>
      <label htmlFor={name} className={styles.label}>
        {label}
      </label>
      {(touched || dirty) &&
        error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  </div>
);

DropDown.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string.isRequired,
  options: PropTypes.any.isRequired,
  meta: PropTypes.object,
};

export default DropDown;



// WEBPACK FOOTER //
// ./src/components/Forms/DropDown.jsx